import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/data';

export default function ArticleSection() {
  const { t } = useTranslation();

  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">{t('article.latest')}</h2>
          <Link to="/about" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap">
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>
      </div>
    </section>
  );
}